import React from "react";

interface TooltipIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  className?: string;
  color?: string;
}

const TooltipIcon: React.FC<TooltipIconProps> = ({ size = 16, className, color = "#292D32", ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 17"
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.99975 14.9168C11.6731 14.9168 14.6664 11.9235 14.6664 8.25014C14.6664 4.57681 11.6731 1.58348 7.99975 1.58348C4.32641 1.58348 1.33308 4.57681 1.33308 8.25014C1.33308 11.9235 4.32641 14.9168 7.99975 14.9168ZM8.49975 10.9168C8.49975 11.1901 8.27308 11.4168 7.99975 11.4168C7.72641 11.4168 7.49975 11.1901 7.49975 10.9168L7.49975 7.58348C7.49975 7.31014 7.72641 7.08348 7.99975 7.08348C8.27308 7.08348 8.49975 7.31014 8.49975 7.58348V10.9168ZM7.38641 5.33014C7.41975 5.24348 7.46641 5.17681 7.52641 5.11014C7.59308 5.05014 7.66641 5.00348 7.74641 4.97014C7.82641 4.93681 7.91308 4.91681 7.99975 4.91681C8.08641 4.91681 8.17308 4.93681 8.25308 4.97014C8.33308 5.00348 8.40641 5.05014 8.47308 5.11014C8.53308 5.17681 8.57975 5.24348 8.61308 5.33014C8.64641 5.41014 8.66641 5.49681 8.66641 5.58348C8.66641 5.67014 8.64641 5.75681 8.61308 5.83681C8.57975 5.91681 8.53308 5.99014 8.47308 6.05681C8.40641 6.11681 8.33308 6.16348 8.25308 6.19681C8.09308 6.26348 7.90641 6.26348 7.74641 6.19681C7.66641 6.16348 7.59308 6.11681 7.52641 6.05681C7.46641 5.99014 7.41975 5.91681 7.38641 5.83681C7.35308 5.75681 7.33308 5.67014 7.33308 5.58348C7.33308 5.49681 7.35308 5.41014 7.38641 5.33014Z"
      fill={color}
    />
  </svg>
);

export default TooltipIcon;
